import React, { PureComponent } from 'react';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import { BaseInputProps } from '../types';
import { isExpired, isNullLike } from '../utils';

import { Expiries } from './Expiries';
import { Num } from './Num';
import { SettleContext } from '../settleContext';

export interface ExpiryValueInfo {
  expiry: string;
  value?: number;
}

export interface ExpiryValueProps extends BaseInputProps {
  value?: ExpiryValueInfo[];

  onChange?: (val: ExpiryValueInfo[]) => void;

  options?: string[];
}

export class ExpiriesValueList extends PureComponent<ExpiryValueProps> {
  // 结算上下文：由 ValueDefaultsSelector 按 GLOBAL/ASSET/BOT 作用域注入，用于 expiry 到期判断
  static contextType = SettleContext;
  declare context: React.ContextType<typeof SettleContext>;

  value: ExpiryValueInfo[] = [];

  isEmptyItem = (item: ExpiryValueInfo) => {
    return !item.expiry?.trim() && isNullLike(item.value);
  };

  onChange = (i: number, val: any, key?: keyof ExpiryValueInfo) => {
    const value = [...this.value];
    if (!value[i]) value[i] = { expiry: '' };
    if (key) value[i][key] = val as never;
    else value[i] = { ...value[i], ...val };
    this.props.onChange?.(
      value.length === 1 && this.isEmptyItem(value[0]) ? [] : value,
    );
  };

  onAdd = (i: number) => {
    const value = [...this.value];
    value.splice(i + 1, 0, { expiry: '' });
    this.props.onChange?.(value);
    this.props.onBlur?.();
  };

  onDel = (i: number) => {
    const value = [...this.value];
    value.splice(i, 1);
    this.props.onChange?.(
      value.length === 1 && this.isEmptyItem(value[0]) ? [] : value,
    );
    this.props.onBlur?.();
  };

  render() {
    this.value = this.props.value?.filter(it => !isExpired(it.expiry, this.context)) || [];
    // if (!this.value.length && !this.props.readonly)
    //   this.value.push({ expiry: '' });
    return (
      <div
        className={
          this.props.className
        }
        style={this.props.style}
      >
        {this.props.readonly ? (
          this.props.value?.length ? (
            this.value
              .filter(it => it.expiry)
              .map((it, i) => (
                <span key={i}>
                  {it.expiry}
                  <span>/</span>
                  {!isNullLike(it.value) ? it.value : '-'}
                  <br />
                </span>
              ))
          ) : (
            '-'
          )
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-6 gap-4 p-2">
            <div className="font-medium text-gray-700 col-span-2">Expiry</div>
            <div className="font-medium text-gray-700 col-span-2">Value</div>
            <div className="rounded-md"></div>
            {
              this.value.length > 0 ? <div className="rounded-md"></div> : <div className="flex items-center space-x-2">
              <button 
                className="p-1 rounded-full hover:bg-blue-100 transition-colors"
                onClick={this.onAdd.bind(null, 0)}
                aria-label="Add item"
              >
                <PlusOutlined />
              </button>
            </div>
            }
            {this.value.map((it, i) => (
              <React.Fragment key={i}>
                <div className="flex items-center col-span-2">
                  <Expiries
                    className="w-full max-w-[20rem]"
                    multiple={false}
                    options={this.props.options}
                    value={[it.expiry]}
                    onChange={val => this.onChange(i, val[0], 'expiry')}
                    calcDisabled={expiry =>
                      this.value.some(
                        item => item !== it && item.expiry === expiry,
                      )
                    }
                    onBlur={this.props.onBlur}
                  />
                </div>
                <div className="flex items-center col-span-2">
                  <Num
                    className="w-full max-w-[12rem]"
                    value={it.value}
                    onChange={val => this.onChange(i, { value: val })}
                    onBlur={this.props.onBlur}
                  />
                </div>
                <div></div>
                <div className="flex items-center space-x-2">
                  <button 
                    className="p-1 rounded-full hover:bg-blue-100 transition-colors"
                    onClick={this.onAdd.bind(null, i)}
                    aria-label="Add item"
                  >
                    <PlusOutlined />
                  </button>
                  <button 
                    className="p-1 rounded-full hover:bg-red-100 transition-colors"
                    onClick={this.onDel.bind(null, i)}
                    aria-label="Delete item"
                  >
                    <DeleteOutlined />
                  </button>
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    );
  }
}
